<!-- 
  position="topright" 
-->
<p-dialog
  id="globalDialog"
  [visible]="true"
  [resizable]="false"
  [draggable]="false"
  class="global-filter-positioned"
  [closable]="false"
  (visibleChange)="visibleChange($event)">
  <form [formGroup]="filterForm" >
    <div class="formgrid grid w-4 flex-nowrap">
      <div class="field mb-0 mr-2">
        <p-multiSelect
          class="uppercase"
          [options]="$any((enterprises$ | async) ?? [])"
          appendTo="body"
          optionLabel="name"
          optionValue="id"
          display="chip"
          formControlName="enterprises"
          [filter]="true"
          [lazy]="true"
          [resetFilterOnHide]="true"
          (onChange)="selectEnterprise($event)"
          (onFilter)="filterEnterprise($event)"
          (onBlur)="enterpriseOnBlur()"
          [style]="{'minWidth':'200px', 'width': '200px'}"
          placeholder="Select Enterprises">
          <ng-template pTemplate="empty">
            <ul style="list-style-type:none; padding: 0px" *ngIf="isEnterpriseLoading">
              <li *ngFor="let i of [0, 1, 2]" class="mb-3">
                <div class="flex">
                  <p-skeleton size="2rem" styleClass="mr-2"></p-skeleton>
                  <div style="flex: 1" class="mt-2">
                      <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                  </div>
                </div>
              </li>
            </ul>
            <div *ngIf="isEnterpriseLoading === false">No results found.</div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="field mb-0 mr-2">
        <p-multiSelect
          class="uppercase"
          [options]="$any((brands$ | async) ?? [])"
          appendTo="body"
          optionLabel="name"
          optionValue="id"
          display="chip"
          formControlName="brands"
          [filter]="true"
          [lazy]="true"
          [resetFilterOnHide]="true"
          (onChange)="selectBrand($event)"
          (onFilter)="filterBrand($event)"
          (onBlur)="brandOnBlur()"
          [style]="{'minWidth':'180px', 'width': '180px'}"
          placeholder="Select Brands">
            <ng-template pTemplate="empty">
              <ul style="list-style-type:none; padding: 0px" *ngIf="isBrandLoading">
                <li *ngFor="let i of [0, 1, 2]" class="mb-3">
                  <div class="flex">
                    <p-skeleton size="2rem" styleClass="mr-2"></p-skeleton>
                    <div style="flex: 1" class="mt-2">
                        <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                    </div>
                  </div>
                </li>
              </ul>
              <div *ngIf="isBrandLoading === false">No results found.</div>
          </ng-template>
        </p-multiSelect>
      </div>

      <div class="field mb-0">
        <p-multiSelect
          (onChange)="selectHotel($event)"
          (onFilter)="filterHotel($event)"
          (onBlur)="hotelOnBlur()"
          [filter]="true"
          [lazy]="true"
          [options]="$any((hotels$ | async) ?? [])"
          [style]="{'minWidth':'180px', 'width': '180px'}"
          [panelStyle]="{ minWidth: '30em', maxHeight: '390px', overflow: 'auto' }"
          [virtualScrollItemSize]="50"
          [virtualScroll]="true"
          [showToggleAll]="!selectSingleHotel"
          [resetFilterOnHide]="true"
          appendTo="body"
          class="uppercase"
          display="chip"
          formControlName="hotels"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Hotels">
          <ng-template pTemplate="empty">
            <ul style="list-style-type:none; padding: 0px" *ngIf="isHotelLoading">
              <li *ngFor="let i of [0, 1, 2]" class="mb-3">
                <div class="flex">
                  <p-skeleton size="2rem" styleClass="mr-2"></p-skeleton>
                  <div style="flex: 1" class="mt-2">
                      <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                  </div>
                </div>
              </li>
            </ul>
            <div *ngIf="isHotelLoading === false">No results found.</div>
          </ng-template>
        </p-multiSelect>
      </div>
    </div>
  </form>
</p-dialog>
